/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientCaseModel } from '../../models/client-case-model';

export interface GetClientCase$Json$Params {

/**
 * id of case to retrieve
 */
  caseId: number;

/**
 * survey type id for the extended case information
 */
  surveyTypeId: number;
}

export function getClientCase$Json(http: HttpClient, rootUrl: string, params: GetClientCase$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCaseModel>> {
  const rb = new RequestBuilder(rootUrl, getClientCase$Json.PATH, 'get');
  if (params) {
    rb.path('caseId', params.caseId, {});
    rb.query('surveyTypeId', params.surveyTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientCaseModel>;
    })
  );
}

getClientCase$Json.PATH = '/api/Case/{caseId}';
